module.exports = __webpack_public_path__ + "static/media/logomax3dpro.aed3242e.png";